import { Component, inject, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';

import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'toast-notification',
  imports: [NgTemplateOutlet, NgbToastModule],
  templateUrl: './toast-notification.component.html',
  styleUrl: './toast-notification.component.scss'
})
export class ToastNotificationComponent {
  readonly notificationService = inject(NotificationService);

  constructor() { }

  isTemplate(toast: any) { return toast.textOrTpl instanceof TemplateRef; }
}
